// extracted by mini-css-extract-plugin
export var cancelButton = "_oa-5";
export var content = "_oa-3";
export var createButton = "_oa-6";
export var drawerContainer = "_oa-0";
export var footer = "_oa-2";
export var header = "_oa-1";
export var orderFormColumn = "_oa-4";